import { render, staticRenderFns } from "./CustomerContact.vue?vue&type=template&id=68d6bcc0&scoped=true&"
import script from "./CustomerContact.vue?vue&type=script&lang=js&"
export * from "./CustomerContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6bcc0",
  null
  
)

export default component.exports